import { render, staticRenderFns } from "./FiltersModal.vue?vue&type=template&id=687e4cbc&scoped=true&lang=pug"
import script from "./FiltersModal.vue?vue&type=script&lang=js"
export * from "./FiltersModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687e4cbc",
  null
  
)

export default component.exports